// removed by extract-text-webpack-plugin
module.exports = {"menuWrap":"qempo_Menu_menuWrap-g9YMweI","separator":"qempo_Menu_separator-tJ00jOv","disabled":"qempo_Menu_disabled-2smzYnr","orange":"qempo_Menu_orange-2MOgWVQ","lightBlue":"qempo_Menu_lightBlue-2iY0w0R","red":"qempo_Menu_red-1XezC6-"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/DotsMenu/Menu/Menu.scss
// module id = 590
// module chunks = 0